import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { TooltipIcon } from '@naf-simba/elements-tooltips';
import { colors } from '@naf-simba/theme';
import SimpleTextLink from '../../../../components/simple-textlink/SimpleTextLink';

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  gap: ${spacing.space24};
  margin-top: ${spacing.space24};
`;

export const LabelTextWrapper = styled.div<{ $isHidden: boolean }>`
  display: ${({ $isHidden }) => ($isHidden ? 'none' : 'flex')};
  align-items: center;
  gap: ${spacing.space8};
  cursor: pointer;
`;

export const LabelIcon = styled.span<{ $visible: boolean }>`
  display: ${({ $visible }) => ($visible ? 'block' : 'none')};
  font-weight: bold;
`;

export const LabelText = styled(SimpleTextLink)`
  line-height: 3rem;
`;

export const TooltipWrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const StyledTooltip = styled(TooltipIcon)``;

export const CampaignCode = styled.div<{ $visible: boolean }>`
  display: ${({ $visible }) => ($visible ? 'flex' : 'none')};
  flex-direction: column;
`;

export const InputWrapper = styled.div<{ $isHidden: boolean }>`
  display: ${({ $isHidden }) => ($isHidden ? 'none' : 'flex')};
  gap: ${spacing.space16};
  align-items: flex-start;

  @media (min-width: ${breakpoints.m}) and (max-width: ${breakpoints.l}) {
    flex-wrap: wrap;

    > * {
      min-width: 0;
    }
  }
`;

export const CampaignCodeMessageWrapper = styled.div`
  display: flex;
  gap: ${spacing.space16};
  align-items: flex-start;
  color: ${colors.secondary[500]};
`;

export const CampaignCodeMessageText = styled.p`
  margin: 0;
`;
